import React, { useState } from 'react';
import Logo from '../img/logo.png';
import Avatar from '../img/avatar.png';

import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { app } from '../firebase.config';

import { MdShoppingBasket, MdAdd, MdLogout } from 'react-icons/md';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useStateValue } from '../context/StateProvider';
import { actionType } from '../context/reducer';

const Header = () => {
  console.log('Hello from Header');

  const firebaseAuth = getAuth(app);
  const provider = new GoogleAuthProvider();

  const [{ user, cartShow, cartItems }, dispatch] = useStateValue();

  const [isMenu, setIsMenu] = useState(false);
  const [cartDisplay, setCartDisplay] = useState(false);

  const login = async () => {
    if (!user) {
      const {
        user: { refreshToken, providerData },
      } = await signInWithPopup(firebaseAuth, provider);

      dispatch({
        type: actionType.SET_USER,
        user: providerData[0],
      });

      localStorage.setItem('user', JSON.stringify(providerData[0]));
    } else {
      setIsMenu(!isMenu);
    }
  };

  const logout = () => {
    setIsMenu(false);
    localStorage.clear();
    dispatch({
      type: actionType.SET_USER,
      user: null,
    });
  };

  const showCart = () => {
    console.log('Hello from show cart function');
    dispatch({
      type: actionType.SET_CART_SHOW,
      cartShow: !cartShow,
    });
  };

  // const showCart = () => {
  //   console.log('Hello from show cart function');
  //   // setCartDisplay(!cartDisplay);
  // };

  return (
    <header className="fixed z-50 w-screen  p-3 px-4 md:p-6 md:px-16 bg-primary">
      {/* Desktop & tablet */}
      <div className="hidden md:flex justify-center items-center w-full h-full  ">
        <Link to={'/'} className="flex items-center gap-2">
          <img alt="logo" src={Logo} className="w-10 object-cover" />
          <p className="text-headingColor text-xl font-bold">City</p>
        </Link>
        <div className="w-full">
          <motion.ul
            initial={{ opacity: 0, x: 200 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 200 }}
            className="flex justify-center items-center gap-8 ml-auto"
          >
            <li className="text-base text-textColor hover:text-headingColor duration-100 transition-all ease-in-out cursor-pointer">
              Home
            </li>
            <li className="text-base text-textColor hover:text-headingColor duration-100 transition-all ease-in-out cursor-pointer">
              Menu
            </li>
            <li className="text-base text-textColor hover:text-headingColor duration-100 transition-all ease-in-out cursor-pointer">
              About Us
            </li>
            <li className="text-base text-textColor hover:text-headingColor duration-100 transition-all ease-in-out cursor-pointer">
              Service
            </li>
          </motion.ul>
        </div>
        <div className="relative flex items-center justify-center">
          <MdShoppingBasket
            onClick={showCart}
            className="text-textColor text-2xl cursor-pointer"
          />
          {cartItems && cartItems.length > 0 && (
            <div className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-cartNumBg flex items-center justify-center">
              <p className="text-xs text-white font-semibold">
                {cartItems.length}
              </p>
            </div>
          )}
        </div>
        <div className="relative">
          <motion.img
            whileTap={{ scale: 0.6 }}
            src={user ? user.photoURL : Avatar}
            alt="userprofile"
            className="ml-8 w-10 min-w-[40px] h-10 min-h-[40px] shadow-2xl rounded-full"
            onClick={login}
          />

          {isMenu && (
            <motion.div
              initial={{ opacity: 0, scale: 0.6 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.6 }}
              className="w-40 flex flex-col bg-gray-50 shadow-xl rounded-lg absolute top-12 right-0 px-2 py-2"
            >
              {user && user.email === 'leleduc@gmail.com' && (
                <Link to={'/createItem'} onClick={() => setIsMenu(false)}>
                  <p className="px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base">
                    New Item <MdAdd />
                  </p>
                </Link>
              )}
              <p
                className="px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base"
                onClick={logout}
              >
                Logout <MdLogout />
              </p>
            </motion.div>
          )}
        </div>
      </div>

      {/* Mobile */}
      <div className="flex md:hidden items-center justify-between w-full h-full">
        <div
          className="relative flex items-center justify-center"
          onClick={showCart}
        >
          <MdShoppingBasket className="text-textColor text-2xl cursor-pointer" />
          {cartItems && cartItems.length > 0 && (
            <div className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-cartNumBg flex items-center justify-center">
              <p className="text-xs text-white font-semibold">
                {cartItems.length}
              </p>
            </div>
          )}
        </div>

        <Link to={'/'} className="flex items-center gap-2">
          <img alt="logo" src={Logo} className="w-10 object-cover" />
          <p className="text-headingColor text-xl font-bold">City</p>
        </Link>

        <div className="relative">
          <motion.img
            whileTap={{ scale: 0.6 }}
            src={user ? user.photoURL : Avatar}
            alt="userprofile"
            className="ml-8 w-10 min-w-[40px] h-10 min-h-[40px] shadow-2xl rounded-full"
            onClick={login}
          />
          {isMenu && (
            <motion.div
              initial={{ opacity: 0, scale: 0.6 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.6 }}
              className="w-40 flex flex-col bg-gray-50 shadow-xl rounded-lg absolute top-12 right-0 px-2 py-2"
            >
              {user && user.email === 'leleduc@gmail.com' && (
                <Link to={'/createItem'} onClick={() => setIsMenu(false)}>
                  <p className="px-4 py-2 flex items-center cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base gap-3 ">
                    New Item <MdAdd />
                  </p>
                </Link>
              )}
              <ul className="flex flex-col  ">
                <li
                  className="text-base text-textColor px-4 py-2 hover:bg-slate-100 duration-100 transition-all  ease-in-out cursor-pointer"
                  onClick={() => setIsMenu(false)}
                >
                  Home
                </li>
                <li
                  className="text-base text-textColor px-4 py-2 hover:bg-slate-100 duration-100 transition-all  ease-in-out cursor-pointer"
                  onClick={() => setIsMenu(false)}
                >
                  Menu
                </li>
                <li
                  className="text-base text-textColor px-4 py-2 hover:bg-slate-100 duration-100 transition-all  ease-in-out cursor-pointer"
                  onClick={() => setIsMenu(false)}
                >
                  About Us
                </li>
                <li
                  className="text-base text-textColor px-4 py-2 hover:bg-slate-100 duration-100 transition-all  ease-in-out cursor-pointer"
                  onClick={() => setIsMenu(false)}
                >
                  Service
                </li>
              </ul>
              <p
                className="m-2 p-2 rounded-md shadow-md flex items-center cursor-pointer justify-center bg-gray-200 hover:bg-gray-300 transition-all duration-100 ease-in-out text-textColor text-base gap-3"
                onClick={logout}
              >
                Logout <MdLogout />
              </p>
            </motion.div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
